import $ from 'cash-dom';

$(() => {
  const $header = $('.js-header');
  const $headerTgl = $('.js-headerTgl');
  const $searchTgl = $('.js-search');
  const $searchArea = $('.js-searchArea');
  // const $listToMegaNav = $('.js-listToMegaNav');
  const $megaSearchClose = $('.js-megaSearchClose');

  function detectClickOutside(event) {
    if (!$(event.target).closest('.js-header').length) {
      setMegaSearch(false); // eslint-disable-line
    }
  }

  function setMegaSearch(isActive) {
    console.log('setting megaSearch', isActive);
    const method = isActive ? 'addClass' : 'removeClass';
    $searchArea[method]('isActive');
    $searchArea.attr('aria-hidden', !isActive);

    if (isActive) {
      $searchArea.find('input')[0].focus();
      $megaSearchClose.on('click', () => {
        setMegaSearch(false);
      });
      $(document).on('click', detectClickOutside);
    } else {
      $searchTgl[0].focus();
      $megaSearchClose.off('click');
      $(document).off('click', detectClickOutside);
    }
  }

  // Mobile
  $headerTgl.on('click', () => $header.toggleClass('isActive'));

  // Desktop
  $searchTgl.on('click', (e) => {
    e.preventDefault();
    setMegaSearch(true);
  });
});
